/**
 * Single source of truth for tree pricing (USD) on the frontend.
 * Must stay in sync with backend/utils/pricing.js.
 *
 * Tiers:
 *   - individual : $5.00 / tree
 *   - grove (5)  : $20.00 flat  ($4.00 / tree)
 *   - patch (20) : $70.00 flat  ($3.50 / tree)
 *   - custom     : $5.00 / tree
 *
 * Package discounts apply only at the exact qualifying quantity
 * (5 for grove, 20 for patch). Any other quantity is $5/tree.
 */

export const PRICE_PER_TREE_USD = 5.0;

/** Total base price in USD (dollars) for a purchase. */
export function getBasePriceUSD(trees: number, packageType: string = 'individual'): number {
  const count = Number(trees);

  if (packageType === 'grove' && count === 5) {
    return 20.0; // $4/tree
  }
  if (packageType === 'patch' && count === 20) {
    return 70.0; // $3.50/tree
  }
  return count * PRICE_PER_TREE_USD;
}
